export default "__VITE_PUBLIC_ASSET__bd43faf5__"